import { Component, OnInit } from "@angular/core";
import { SidebarRoute } from "src/app/material-module/custom-sidebar/custom-sidebar.component";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "admin-panel",
  templateUrl: "./admin-panel.component.html",
  styleUrls: ["./admin-panel.component.scss"],
})
export class AdminPanelComponent implements OnInit {
  routes = [
    new SidebarRoute("Utenti", "users"),
    new SidebarRoute("Comuni", "comuni"),
    new SidebarRoute("Stati incarico", "stati-incarico"),
    new SidebarRoute("Tipi Polizze", "tipi-polizze"),
    new SidebarRoute("Workflow", "workflow-steps"),
    new SidebarRoute("Tipi altro soggetto", "tipi-altro-soggetto"),
    new SidebarRoute("Studi", "studi"),
    new SidebarRoute("Filiali", "filiali"),
    new SidebarRoute("Gruppi di compagnie", "gruppi"),
    new SidebarRoute("Templates per documenti", "templates"),
    new SidebarRoute("Tipi di template", "tipi-template"),
    new SidebarRoute("Segnalibri", "segnalibri"),
    new SidebarRoute("Collegamenti", "collegamenti"),
    new SidebarRoute("Suggerimenti", "suggerimenti"),
    new SidebarRoute("Annunci", "annunci"),
    new SidebarRoute("Disposizioni Compagnie", "disposizioni-compagnie"),
    new SidebarRoute("Zone Geografiche", "zone-geografiche"),
    new SidebarRoute("Gruppi Rami", "gruppi-rami"),
    new SidebarRoute("Gruppi Tipi Danno", "gruppi-tipi-danno"),
    //TODO controllo solo studio 1
  ];

  constructor(/*private authService: AuthService*/) {}

  async ngOnInit() {
    //let loggedInUser = await this.authService.loggedInUser.getValue();
    //if (loggedInUser.studio_id == 1)
    this.routes.push(new SidebarRoute("Estensioni", "estensioni"));
    this.routes.push(new SidebarRoute("Preferenze Agenzie", "preferenze-agenzie"));
    this.routes.push(new SidebarRoute("Preferenze Amministratori", "preferenze-amministratori"));
  }
}
